import * as methods from './methods'
import * as methodsConfig from './methodsConfig'

const payment = {
  methods,
  methodsConfig
}

export default payment
